import { Injectable } from '@angular/core';
import { DisplayStageNatureTypeDto } from '../../beneficiaries/beneficiary-folder/stages/display-stage-nature-type.dto';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class StageNatureTypeService {
  constructor(private readonly api: ApiService) {}

  public async findAll(): Promise<DisplayStageNatureTypeDto[]> {
    return this.api.get<DisplayStageNatureTypeDto[]>(environment.api.naturesTypes);
  }

  public async findById(id: number): Promise<DisplayStageNatureTypeDto> {
    return this.api.get<DisplayStageNatureTypeDto>(`${environment.api.naturesTypes}/${id}/findById`);
  }

  public async findFseNatures(): Promise<DisplayStageNatureTypeDto[]> {
    return this.api.get<DisplayStageNatureTypeDto[]>(environment.api.naturesTypes + '/fseNatures');
  }

  public async findAllNaturesTypesById(): Promise<Map<number, DisplayStageNatureTypeDto>> {
    const stageNaturesTypes: DisplayStageNatureTypeDto[] = await this.findAll();
    return new Map<number, DisplayStageNatureTypeDto>(
      stageNaturesTypes.map((type: DisplayStageNatureTypeDto) => [type.id, type] as [number, DisplayStageNatureTypeDto]),
    );
  }
}
